"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishDocumentModal = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const publish_document_1 = require("../../../../../../api/calls/document/draft/publish_document");
const document_1 = require("../../../../../../reducers/slices/document/document");
const main_1 = require("../../../../../../reducers/slices/main");
const PublishDocumentModal = ({ documentId, existingSigners, onClose, onPublishSuccess, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const signers = existingSigners || [];
    const handlePublish = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        // Validate signers exist
        if (!signers || signers.length === 0) {
            dispatch((0, main_1.setMessageModal)({
                title: "Error!",
                messages: ["No signers assigned to this document. Please add signers before publishing."],
            }));
            return;
        }
        dispatch((0, document_1.setIsLoading)(true));
        try {
            // Only send required fields (backend validation expects only these)
            const cleanedSigners = signers.map((signer) => ({
                first_name: signer.first_name,
                last_name: signer.last_name,
                email: signer.email,
            }));
            const payload = {
                document_id: documentId,
                signers: cleanedSigners,
            };
            const response = yield (0, publish_document_1.publish_document)(payload);
            if (response.success) {
                onPublishSuccess === null || onPublishSuccess === void 0 ? void 0 : onPublishSuccess();
                onClose();
            }
            else {
                console.error("Publish failed:", response);
                // Extract validation errors if available
                let errorMessages = [response.message || "Unknown error occurred while publishing document"];
                // Check if it's a Celebrate validation error
                if ((_c = (_b = (_a = response.content) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.validation) {
                    const validation = response.content.response.data.validation;
                    errorMessages = [`Validation failed: ${JSON.stringify(validation)}`];
                }
                else if ((_f = (_e = (_d = response.content) === null || _d === void 0 ? void 0 : _d.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message) {
                    errorMessages = [response.content.response.data.message];
                }
                dispatch((0, main_1.setMessageModal)({
                    title: "Publish Failed",
                    messages: errorMessages,
                }));
            }
        }
        catch (error) {
            console.error("Error publishing document:", error);
            dispatch((0, main_1.setMessageModal)({
                title: "Error!",
                messages: ["An error occurred while publishing the document"],
            }));
        }
        finally {
            dispatch((0, document_1.setIsLoading)(false));
        }
    });
    return (react_1.default.createElement("div", { className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center", style: { zIndex: 9999 } },
        react_1.default.createElement("div", { className: "bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl" },
            react_1.default.createElement("h2", { className: "text-2xl font-bold mb-4" }, "Confirm Document Publishing"),
            react_1.default.createElement("p", { className: "text-sm text-gray-600 mb-6" }, "The following signers will receive email invitations to sign this document:"),
            react_1.default.createElement("div", { className: "flex flex-col gap-3 mb-6 bg-gray-50 p-4 rounded-lg" }, signers && signers.length > 0 ? (signers.map((signer, index) => (react_1.default.createElement("div", { key: index, className: "flex items-center gap-4 p-3 bg-white rounded border border-gray-200" },
                react_1.default.createElement("div", { className: "flex-shrink-0 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-semibold" }, index + 1),
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement("div", { className: "font-medium text-gray-900" },
                        signer.first_name,
                        " ",
                        signer.last_name),
                    react_1.default.createElement("div", { className: "text-sm text-gray-600" }, signer.email)))))) : (react_1.default.createElement("div", { className: "text-center text-gray-500 py-4" }, "No signers assigned. Please add signers to the document before publishing."))),
            react_1.default.createElement("div", { className: "flex justify-end gap-3 pt-4 border-t border-gray-200" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Cancel", size: "small", backgroundColor: "bg-gray-200", textColor: "text-gray-700", onClick: onClose }),
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Publish & Send Invitations", size: "small", backgroundColor: "bg-green-500", textColor: "text-white", onClick: handlePublish, enabled: signers && signers.length > 0 })))));
};
exports.PublishDocumentModal = PublishDocumentModal;
